var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39.687,
    viewBox: "0 0 40 39.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.484-64.288a20,20,0,0,1-10,17.32,19.994,19.994,0,0,1-20,0,20,20,0,0,1-10-17.32A1.81,1.81,0,0,1,17.295-66.1a1.81,1.81,0,0,1,1.811,1.811,16.384,16.384,0,0,0,6.4,13,16.39,16.39,0,0,0,14.208,2.843,16.387,16.387,0,0,0,10.907-9.538A16.39,16.39,0,0,0,49.7-72.445a16.4,16.4,0,0,0-12.028-8.078A16.393,16.393,0,0,0,23.94-75.9l3.151-.263a1.816,1.816,0,0,1,1.96,1.661,1.816,1.816,0,0,1-1.661,1.96l-7.243.607h-.57l-.136-.045-.254-.163h-.136l-.127-.1-.2-.19-.1-.118-.109-.127a.483.483,0,0,1-.045-.072v-.054a1.347,1.347,0,0,1-.081-.136.436.436,0,0,1,0-.109.983.983,0,0,1-.054-.163v-.344l-.38-7.451a1.812,1.812,0,0,1,1.72-1.9,1.812,1.812,0,0,1,1.9,1.72l.136,2.716a20,20,0,0,1,14.011-5.5A20.008,20.008,0,0,1,49.6-78.142a19.989,19.989,0,0,1,5.882,13.854Z",
    transform: "translate(-15.484 83.974)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplay);
export default __webpack_public_path__ + "static/media/icon-replay.98a459c2.svg";
export { ForwardRef as ReactComponent };